<h1 mat-dialog-title>{{ 'communications.fields.chooseRecipient' | translate }}</h1>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <div *ngIf="data.isMaster" class="row">
    <div class="col-12 mb-3">
      <mat-label>{{ 'communications.properties' | translate }}</mat-label>
      <ng-select
        [items]="options$ | async"
        bindLabel="name"
        [addTag]="false"
        [multiple]="false"
        [hideSelected]="true"
        [trackByFn]="trackByFn"
        [minTermLength]="1"
        [typeahead]="optionsInput$"
        [loading]="optionsLoading"
        [placeholder]="placeholder"
        [typeToSearchText]="typeToSearchText"
        [clearAllText]="clearAllText"
        [notFoundText]="notFoundText"
        [loadingText]="loadingText"
        [(ngModel)]="selectedOption"
        (change)="onChange($event)"
        >
      </ng-select>
    </div>
  </div>
  <div *ngIf="filteredRecipients" class="row">
    <div class="col-6">
      <mat-form-field>
        <mat-label>Cerca email</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Cerca..." [value]="searchValue">
      </mat-form-field>
      <!-- Checkboxes -->
      <ng-container *ngFor="let recipient of filteredRecipients">
        <div class="text-wrapper">
          <mat-checkbox [checked]="selectAll || recipient.selected"
            (change)="onRecipientSelected(recipient, $event.checked)" class="checkbox-insert">
            {{ recipient.firstName }} {{ recipient.lastName }} ({{ recipient.email }})
          </mat-checkbox>
        </div>
      </ng-container>
    </div>
    <div class="col-6">
      <mat-checkbox [checked]="selectAll" (change)="onSelectAll($event.checked)"
        class="heading-checkbox-with-margin checkbox-insert">
        Seleziona tutto
      </mat-checkbox>
    </div>
  </div>
</mat-dialog-content>
<div class="row custom-dialog-footer">
  <div class="col-12 col-md-6 text-left">
    <a mat-button (click)="onClose()" mat-raised-button mat-default
      class="ml-3">{{ 'common.cta.close' | translate }}</a>
  </div> <!-- /.col -->
  <div class="col-12 col-md-6 text-right">
    <mat-spinner-button (btnClick)="onFormSubmit()" role="submit" [options]="formBtnOptions" class="btn-elevate">
    </mat-spinner-button>
  </div> <!-- /.col -->
</div> <!-- /.row -->